export default {
  viewType: 'delivery-deploy-project-detail',
  breadcrumb: { title: '', action: '', class: '' },
  params: {}
}
